import { render, staticRenderFns } from "./LabelSets.vue?vue&type=template&id=7f4113df&scoped=true&"
import script from "./LabelSets.vue?vue&type=script&lang=js&"
export * from "./LabelSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4113df",
  null
  
)

export default component.exports